import copyToClipboard from 'copy-to-clipboard';
import React, {useCallback} from 'react';
import {Slide, toast} from 'react-toastify';

import {QuickStartIcon} from '../QuickStartIcon';
import * as S from './CodeSnippet.styles';

type CodeCopyButtonProps = {
  copyContent: string;
  analyticsEvent: (data: any) => void;
  analyticsDefaultProperties: Record<string, any>;
};

export const CodeCopyButton = ({
  copyContent,
  analyticsEvent,
  analyticsDefaultProperties,
}: CodeCopyButtonProps) => {
  const onCopyClick = useCallback(() => {
    copyToClipboard(copyContent);
    toast('Copied to clipboard', {
      transition: Slide,
    });

    analyticsEvent({
      ...analyticsDefaultProperties,
      codeSnippet: copyContent,
    });
  }, [copyContent, analyticsEvent, analyticsDefaultProperties]);

  return (
    <S.CodeCopyButton onClick={onCopyClick}>
      <QuickStartIcon name="copy" /> Copy
    </S.CodeCopyButton>
  );
};
